<template>
  <!-- Main Content -->
  <v-card flat class="settings-card">
    <!-- Contents -->
    <v-container>
      <v-card-title class="settings-header-text d-flex justify-space-between">
        <div class="mb-2">Request Review</div>
      </v-card-title>
      <v-card-subtitle class="px-md-0 settings-section-main-content">
        Use the link below to request anonymous reviews. Or, if you send a
        personalized request by text message to a customer we'll track their
        response in their customer record.
      </v-card-subtitle>
      <v-card-text>
        <v-text-field
          class="text-body-1"
          outlined
          :value="genericRequestUrl"
          append-outer-icon="mdi-content-copy"
          @click:append-outer="copyToClipboard(genericRequestUrl)"
        ></v-text-field>
      </v-card-text>
      <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
        {{ snackbarText }}
        <template v-slot:action="{ attrs }"> </template>
      </v-snackbar>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "RequestReview",
  components: {},
  data() {
    return {
      genericRequestUrl: null,
      snackbar: false,
      snackbarTimeout: 4000,
      snackbarText: null
    };
  },
  created() {
    this.getReviewLink();
  },
  computed: {
    reviewFeedbacks() {
      const feedbacks = this.$store.getters[
        "entities/bizReviewFeedbacks/query"
      ]()
        .orderBy("createdAt", "desc")
        .get();
      return feedbacks.map((val, i) => {
        const tempCust = this.$store.getters["entities/customerLookups/find"](
          val.customerId
        );
        return {
          id: val.id,
          date: val.createdAt
            ? new Date(val.createdAt).toLocaleDateString("en-US")
            : "",
          message: val.message,
          customerId: val.customerId,
          customerName: tempCust && tempCust.name ? tempCust.name : "Anonymous"
        };
      });
    }
  },
  watch: {},
  methods: {
    async getReviewLink() {
      let response = await this.$store.dispatch(
        "entities/redirectLink/getRedirectLink",
        {
          customerId: null
        }
      );
      if (response && response.url) {
        this.genericRequestUrl = response.url;
      }
    },
    copyToClipboard(text) {
      let vueThis = this;
      navigator.clipboard
        .writeText(text)
        .then(() => {
          vueThis.snackbarText = "Review request URL copied to the clipboard!";
          vueThis.snackbar = true;
        })
        .catch(err => {
          throw err;
        });
    }
  }
};
</script>

<style scoped lang="stylus"></style>
